import {RouterModule, Routes} from '@angular/router';

import {LayoutComponent} from './layout/layout.component';
import {Page404Component} from './error-pages/404/404.component';
import {Page500Component} from './error-pages/500/500.component';
import {PageMaintenanceComponent} from './error-pages/maintenance/maintenance.component';
import {Page401Component} from './error-pages/401/401.component';
import {MsalGuard} from '@azure/msal-angular';
import {DirectAccessGuard} from './error-pages/directaccessguard';
import {BrowserUtils} from '@azure/msal-browser';
import {isEntraAuth} from './core/deployment';

const AppRoutes: Routes = [
  {path: '404', component: Page404Component, canActivate: [DirectAccessGuard]},
  {path: '401', component: Page401Component, canActivate: [DirectAccessGuard]},
  {path: '500', component: Page500Component, canActivate: [DirectAccessGuard]},
  {path: 'maintenance', component: PageMaintenanceComponent},
  {
    path: 'install',
    loadChildren: () => import('./install-page/install-page.module').then(m => m.InstallPageModule),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: isEntraAuth() ? [MsalGuard] : [],
    canActivateChild: isEntraAuth() ? [MsalGuard] : [],
  },
  {path: '**', redirectTo: '/404', pathMatch: 'full'},
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {
  useHash: true, // Don't perform initial navigation in iframes or popups
  initialNavigation:
    !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled',
});
